import { SET_SETTINGS_ERROR, UPDATE_PROFILE } from "./constants";

export function updateUserProfile(data,cbSuccess){
    return{
        type: UPDATE_PROFILE,
        data,
        cbSuccess,
    }
}
export function setError(settingsError){
    return{
        type: SET_SETTINGS_ERROR,
        settingsError,
    }
}